import { useEffect, useState } from 'react';
import { OrderHistoryResponse } from 'shared/types/cart';
import { makeSDKCallWithRetries } from 'helpers/makeSDKCallWithRetries';
import { withCookieValidation } from 'helpers/utils/cookie';
import { getAccountId, useAppSelector } from 'store';
import { getOrders } from './helpers';

export const useOrders = () => {
  const customerId = useAppSelector(getAccountId);
  const [orders, setOrders] = useState<OrderHistoryResponse>({
    orders: null,
    isError: false,
    isLoading: true,
  });

  useEffect(() => {
    const getOrdersOnLoad = async () => {
      const response = await withCookieValidation(() =>
        makeSDKCallWithRetries('orders/getOrders', customerId, () =>
          getOrders(customerId),
        ),
      );

      if (response.isError || response.data.isError) {
        const error = response.isError ? response.error.message : '';
        console.warn(
          `Encountered exception while fetching order history for customer: ${customerId} with error: ${error}`,
        );

        setOrders({ orders: null, isError: true, isLoading: false });
      } else {
        setOrders({ orders: response.data, isError: false, isLoading: false });
      }
    };
    // eslint-disable-next-line @typescript-eslint/no-floating-promises
    getOrdersOnLoad();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return orders;
};
